import React from "react";
import { Modal } from "antd";

const CPModal = ({
  title,
  visible = false,
  children,
  footer,
  className,
  confirmLoading = false,
  closable = false,
  mask = true,
  maskClosable = false,
  afterClose,
  onClose,
  width = 520,
  onCancel = () => {},
  onOk = () => {},
  okText,
  cancelText,
  centered = true,
  okButtonProps,
  cancelButtonProps,
  bodyStyle,
}) => {
  return (
    <Modal
      destroyOnClose={true}
      title={<div>{title}</div>}
      closable={closable}
      maskClosable={maskClosable}
      mask={mask}
      confirmLoading={confirmLoading}
      className={className}
      width={width}
      visible={visible}
      footer={footer}
      onCancel={onCancel}
      bodyStyle={bodyStyle}
      onOk={onOk}
      afterClose={afterClose}
      onClose={onClose}
      okText={okText}
      cancelText={cancelText}
      centered={centered}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
    >
      {children}
    </Modal>
  );
};

export default CPModal;
